import React from 'react';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import {
  Container,
  Wrapper,
  Heading,
  Panel,
  OrderInfo,
  Status,
  OrderAction,
  MachineStatusWrapper,
} from 'styles/pages/order-details/orderInformation';

const PurpleSwitch = withStyles({
  switchBase: {
    color: '#676a6c',
    '&$checked': {
      color: '#3ab393',
    },
    '&$checked + $track': {
      backgroundColor: '#3ab393',
    },
  },
  checked: {},
  track: {},
})(Switch);

const OrderPickUp = ({ orderDetail = {}, setOrderPickUp }) => {
  return (
    <Container>
      <Wrapper style={{ minHeight: 0 }}>
        <Heading style={{ margin: '0 10px' }}>
          Order Pick Up
          <PurpleSwitch
            checked={!!orderDetail?.PickUp}
            onChange={(e) => setOrderPickUp(e.target.checked)}
          />
        </Heading>

        {orderDetail?.PickUp && (
          <Panel>
            {orderDetail?.PrintProvider === 'CA' ? (
              <div style={{ padding: '0 10px', fontSize: 16, lineHeight: 1.5 }}>
                <div>
                  <b style={{ fontSize: 20 }}>Order Pick Up Address</b>
                </div>
                <div>Big Oven Tees INC.</div>
                <div>122 Middleton St.</div>
                <div>Brantford ON N3S737</div>
                <div>Canada</div>
              </div>
            ) : (
              <OrderInfo>
                <div
                  style={{ padding: '0 10px', fontSize: 16, lineHeight: 1.5 }}>
                  <div>
                    <b style={{ fontSize: 20 }}>Order Pick Up Address</b>
                  </div>
                  <div>Big Oven Tees INC.</div>
                  <div>8742 Buffalo Avenue</div>
                  <div>Niagara Falls NY 14304</div>
                  <div>United States</div>
                </div>
              </OrderInfo>
            )}
          </Panel>
        )}
      </Wrapper>
    </Container>
  );
};

export default OrderPickUp;
